// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Users/jeremy/code/web/abcBillGift-super/src/pages/admManage/admDic/model';
import model_2 from '/Users/jeremy/code/web/abcBillGift-super/src/pages/admManage/admLog/model';
import model_3 from '/Users/jeremy/code/web/abcBillGift-super/src/pages/admManage/admUser/model';
import model_4 from '/Users/jeremy/code/web/abcBillGift-super/src/pages/bill/model';
import model_5 from '/Users/jeremy/code/web/abcBillGift-super/src/pages/subMerchant/model';

export const models = {
model_1: { namespace: 'admManage.admDic.model', model: model_1 },
model_2: { namespace: 'admManage.admLog.model', model: model_2 },
model_3: { namespace: 'admManage.admUser.model', model: model_3 },
model_4: { namespace: 'bill.model', model: model_4 },
model_5: { namespace: 'subMerchant.model', model: model_5 },
} as const
